import {useDispatch, useSelector} from "react-redux";
import LabeledSelect from "../../../components/selects/LabeledSelect";
import {useEffect} from "react";
import {tryLoadPermissions} from "../../../redux/slices/permissionSlice";

const PermissionsSelect = ({

                             className,
                             exclude = [],
                             onPermissionSelect,
                             disabled = false,
                             ...props
                           }) => {

  const dispatch = useDispatch();

  const {init, data, loading, error} = useSelector((state => state.permission.permissions));

  const _data = data.filter((f) => !exclude.some((e) => e.id === f.id));

  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(tryLoadPermissions());
  }, [init, loading, error]);


  return (

    <LabeledSelect label="Select permissions you want to add"
                   value={"value"}
                   options={_data}
                   loading={!init}
                   isDisabled={!init || disabled}
                   getOptionValue={(option) => option.id}
                   getOptionLabel={(option) => option.name}
                   onChange={onPermissionSelect}
                   emptyMsg="No permissions to add" {...props} />
  );
};


export default PermissionsSelect;

